import React, { use, useEffect, useRef, useState } from 'react'
import styles from './Sazuli.module.css'
import IconComponent from '../IconComponent/IconComponent'
import { FaCircleCheck } from 'react-icons/fa6'
import { MdOutlineHeadphones } from 'react-icons/md'
import { VscTools } from 'react-icons/vsc'
import { useLocation } from 'react-router-dom'
import { TeamsType } from '../../utils/Types/TeamTypes'
import axios from 'axios'
import Com from './Com'

export type SazuliProps = {
    setNavBackground: React.Dispatch<React.SetStateAction<boolean>>
}

const Sazuli = (props: SazuliProps) => {

    const [currentType, setCurrentType] = useState(1);
    const [currentImage, setCurrentImage] = useState<string>('https://sazuli.pt/uploads/Compromisso_Default.jpg');
    const [team, setTeam] = useState<TeamsType[]>([]);
    const missao = useRef<HTMLDivElement | null>(null);
    const servicos = useRef<HTMLDivElement | null>(null);
    const equipa = useRef<HTMLDivElement | null>(null);
    const location = useLocation();
    const width = useWindowWidth();

    function useWindowWidth() {
        const [width, setWidth] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => setWidth(window.innerWidth);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return width;
    }

    useEffect(() => {
        props.setNavBackground(true);
    }, []);

    useEffect(() => {

        const params = new URLSearchParams(location.search);
        let targetType: number | null = null;

        if (params.has("missao")) targetType = 0;
        if (params.has("visao")) targetType = 1;
        if (params.has("valores")) targetType = 2;
        else if (params.has("servicos")) targetType = 3;
        else if (params.has("equipa")) targetType = 4;

        if (targetType !== null) {
            setTimeout(() => {
                if (targetType === 0) {
                    missao.current?.scrollIntoView({ behavior: "smooth" })
                    setCurrentType(1);
                };
                if (targetType === 1) {
                    missao.current?.scrollIntoView({ behavior: "smooth" });
                    setCurrentType(2);
                };
                if (targetType === 2){
                    missao.current?.scrollIntoView({ behavior: "smooth" });
                    setCurrentType(0);
                }
                if (targetType === 3) servicos.current?.scrollIntoView({ behavior: "smooth" });
                if (targetType === 4) equipa.current?.scrollIntoView({ behavior: "smooth" });
            }, 300);
        }
    }, [location.search]);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [team] = await Promise.all([
                    axios.get("https://sazuli.pt/api/team"),
                ]);
                setTeam(team.data);
            } catch (err) {
                console.error("Data fetch error:", err);
            }
        };
        fetchAll();
    }, [])

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.header_item}>
                    <span className={styles.header_title}>Do chão ao charme</span>
                </div>
                <div className={styles.header_item}>
                    <div className={styles.header_left}>
                        <span className={styles.header_comment}>“Acreditamos que fazer bem feito não é apenas entregar qualidade. É estar presente nas escolhas que moldam a vida de quem nos procura.”</span>
                        <span className={styles.header_author}>Brigite Meireles</span>
                        <span className={styles.header_position}>SAZULI CEO</span>
                    </div>
                </div>
            </div>
            <div className={styles.content} ref={missao}>
                <div className={styles.types}>
                    {['Valores', 'Missão', 'Visão'].map((label, i) => (
                        <span
                            key={i}
                            className={currentType === i ? styles.active : ''}
                            onClick={() => setCurrentType(i)}
                        >
                            {label}
                        </span>
                    ))}
                </div>
                {currentType === 0 && (
                    <div className={styles.types_info}>
                        <div className={styles.image_types}>
                            <img src={
                                `https://sazuli.pt/uploads/valores.jpg`
                            }
                                alt="Valores"
                            />
                        </div>
                        <div className={styles.text_types}>
                            <span className={styles.text_title}>Ajudar cada cliente a construir o seu espaço com confiança e propósito.</span>
                            <span className={styles.text_info}>A nossa missão é garantir que cada cliente encontre, na nossa equipa e exposição, os produtos certos e o apoio necessário para criar espaços com identidade.</span>
                            <div className={styles.text_bullet}>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Aconselhar com proximidade e transparência.</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Garantir acesso a soluções técnicas de marcas certificadas.</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Proporcionar uma experiência de compra fluida, confortável e acessível.</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Apostar em relações duradouras, que vão além da entrega do produto.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {currentType === 1 && (
                    <div className={`${styles.types_info} ${styles.tp_info_2}`}>
                        <div className={styles.text_types}>
                            <span className={styles.text_title}>Os princípios que definem o nosso caminho.</span>
                            <span className={styles.text_info}>Estes são os pilares que orientam as nossas decisões, relações e a forma como acompanhamos cada cliente, com proximidade, profissionalismo e integridade.</span>
                            <div className={styles.text_bullet}>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Proximidade com o Cliente</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Rigor e Profissionalismo</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Responsabilidade e Sustentabilidade</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Confiança e Transparência</span>
                                </div>
                            </div>
                        </div>
                        <div className={styles.image_types}>
                            <img src={
                                `https://sazuli.pt/uploads/missao.jpg`
                            }
                                alt="Missão Imagem"
                            />
                        </div>
                    </div>
                )}
                {currentType === 2 && (
                    <div className={styles.types_info}>
                        <div className={styles.image_types}>
                            <img src={
                                `https://sazuli.pt/uploads/visao.png`
                            }
                                alt="Visão Imagem"
                            />
                        </div>
                        <div className={styles.text_types}>
                            <span className={styles.text_title}>Ser uma referência nacional em soluções para espaços de habitação e bem-estar.</span>
                            <span className={styles.text_info}>A Sazuli projeta o futuro com o objetivo de ser uma marca de confiança. Mais do que uma loja, queremos ser parceiros na criação de casas com identidade.</span>
                            <div className={styles.text_bullet}>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Expandir a presença no mercado nacional com uma imagem moderna.</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Ser reconhecidos pela excelência no atendimento e pela qualidade.</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Inovar na apresentação e aconselhamento de soluções.</span>
                                </div>
                                <div className={styles.bullet}>
                                    <span><IconComponent icon={FaCircleCheck} size={20} color='#003399' /></span>
                                    <span>Estabelecer parcerias duradouras com fornecedores de confiança.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.content2} ref={servicos}>
                <div className={styles.title}>
                    <h1>O nosso compromisso</h1>
                </div>
                <div className={styles.comp_info}>
                    {/* <Com /> */}
                    <div className={styles.comp_item}>
                        <div className={styles.item_comp} style={
                            width < 1000
                                ? { backgroundImage: "url('https://sazuli.pt/uploads/Compromisso 1.jpg')" }
                                : {}
                        }
                            onMouseEnter={() =>
                                width > 1000 && setCurrentImage('https://sazuli.pt/uploads/Compromisso 1.jpg')
                            }
                        >
                            <span><IconComponent icon={VscTools} size={25} /></span>
                            <span className={styles.i_c_title}>Acompanhamento personalizado em todo o processo</span>
                            <span className={styles.i_c_text}>Na Sazuli, cada cliente tem acesso a acompanhamento especializado, do primeiro contacto à entrega final, com apoio técnico e estético adaptado ao seu projeto.</span>
                        </div>
                        <div className={styles.item_comp} style={
                            width < 1000
                                ? { backgroundImage: "url('https://sazuli.pt/uploads/Compromisso 2.jpg')" }
                                : {}
                        }
                            onMouseEnter={() =>
                                width > 1000 && setCurrentImage('https://sazuli.pt/uploads/Compromisso 2.jpg')
                            }
                        >
                            <span><IconComponent icon={MdOutlineHeadphones} size={25} /></span>
                            <span className={styles.i_c_title}>Portfólio de produtos com variedade e qualidade profissional</span>
                            <span className={styles.i_c_text}>Representamos as marcas mais conceituadas do setor, com soluções para todo o tipo de obras - residenciais, comerciais e industriais. Desde cerâmicas de grandes formatos a sistemas técnicos e sanitários, cobrimos todas as necessidades com qualidade certificada.</span>
                        </div>
                    </div>
                    <div className={styles.comp_item} id={styles.imageMiddle}>
                        <Com currentImage={currentImage} />
                    </div>
                    <div className={styles.comp_item}>
                        <div className={styles.item_comp} style={
                            width < 1000
                                ? { backgroundImage: "url('https://sazuli.pt/uploads/Compromisso 3.jpg')" }
                                : {}
                        }
                            onMouseEnter={() =>
                                width > 1000 && setCurrentImage('https://sazuli.pt/uploads/Compromisso 3.jpg')
                            }
                        >                            <span><IconComponent icon={VscTools} size={25} /></span>
                            <span className={styles.i_c_title}>Exposição permanente com soluções em contexto real</span>
                            <span className={styles.i_c_text}>A Sazuli dispõe de uma exposição moderna e dinâmica onde é possível visualizar os materiais aplicados, facilitando decisões mais seguras e fidedignas.</span>
                        </div>
                        <div className={styles.item_comp} style={
                            width < 1000
                                ? { backgroundImage: "url('https://sazuli.pt/uploads/Compromisso 4.jpg')" }
                                : {}
                        }
                            onMouseEnter={() =>
                                width > 1000 && setCurrentImage('https://sazuli.pt/uploads/Compromisso 4.jpg')
                            }
                        >                            <span><IconComponent icon={MdOutlineHeadphones} size={25} /></span>
                            <span className={styles.i_c_title}>Confiança construída com mais de 30 anos de experiência</span>
                            <span className={styles.i_c_text}>Mais de três décadas de atividade sólida fazem da Sazuli um parceiro de confiança para milhares de clientes em Portugal. A continuidade familiar na liderança e a dedicação ao serviço fazem parte da identidade da marca.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.content2} ${styles.background}`} ref={equipa}>
                <div className={styles.title}>
                    <h1>A nossa Equipa dedicada</h1>
                </div>
                <div className={styles.teamWrapper}>
                    <div className={styles.team}>
                        {team.map((member) => (
                            <div className={styles.team_member}>
                                <div className={styles.member_name_position}>
                                    <span>{member.name}</span>
                                    <span>{member.position}</span>
                                </div>
                                <img
                                    src={`https://sazuli.pt/uploads/${member.image}`}
                                    alt={member.name}
                                    className={styles.member_image}
                                />
                                <div className={styles.member_contact}>
                                    <a href={`mailto:${member.email}`} className={styles.member_email}>
                                        {member.email}
                                    </a>
                                    <span>{member.number}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sazuli